import { Button, ClickEvent, DataSourceMode, Label, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { Navigation } from "@mcleod/core";
import { AutogenLayoutTableCustomerQuotes } from "./autogen/AutogenLayoutTableCustomerQuotes";
import { LtlQuote } from "./LtlQuote";

export class TableCustomerQuotes extends AutogenLayoutTableCustomerQuotes {

  override onLoad() {
    this.mainDataSource.orderBy = [{field:"shipper_stop.sched_arrive_early", sort: "desc"}];
  }

  buttonOpenQuoteOnClick(event: ClickEvent) {
    const button = event.target as Button;
    button.busy = true;
    const tableRow = TableRow.getContainingTableRow(event.target as Button);
    LtlQuote.slideInCrudDecorator(tableRow.data.get("id"))
    .finally(() => button.busy = false);
  }

  // When exporting to excel the column header titles couldn't be resolved when using the
  // CityState component. Using a label that is not bound to a ModelRow to display the city/state/zip
  // to work around this issue.
  tableQuotesOnRowDisplay(event: TableRowDisplayEvent) {
    const tableRow = event.getTableRow();
    const shipperLbl = tableRow.findComponentById("labelShipperCityState") as Label;
    shipperLbl.caption = tableRow.data.get("shipper_city_state_zip");
    const consigneeLbl = tableRow.findComponentById("labelConsigneeCityState") as Label;
    consigneeLbl.caption = tableRow.data.get("consignee_city_state_zip");
  }
}

